export default function webchats(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        webchat: action.webchat,
      }
    default:
      return state;
  }
}